import React from 'react';
import { AddressForm } from './AddressForm';
import { ADDRESS_PREFIX_MAILING } from '../const';

export function PersonAddressForm({ className, ...props }) {
  return (
    <div className={className}>
      <AddressForm {...props} />
      <AddressForm prefix={ADDRESS_PREFIX_MAILING} {...props} />
    </div>
  );
}

PersonAddressForm.propTypes = {
  ...AddressForm.propTypes,
};
